import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import ButtonApp from "@/components/ButtonApp.vue";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
import scrollTo from "@/mixins/scrollTo";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["formCallIsShown", "breakpoint"]),
    },
    methods: {
        ...uiMapper.mapMutations(["openFormCall"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["videoLink"]),
        ...dataMapper.mapGetters(["formMail"]),
    },
    methods: {
        ...dataMapper.mapMutations([
            "setFormCallTitle",
            "setFormCallScreen",
            "activateFormField",
            "clearForm",
        ]),
    },
});
let MainContentIntro = class MainContentIntro extends Mixins(UiMappers, DataMappers) {
    get formCallMail() {
        return this.formMail("callback");
    }
    async onOpenFormClick() {
        this.clearForm("callback");
        await this.$nextTick();
        this.setFormCallTitle("Забронировать место в смене");
        this.setFormCallScreen("Экран 00");
        this.activateFormField(this.formCallMail);
        this.openFormCall();
    }
    scrollToPrice() {
        scrollTo("#price", 0, 1000);
    }
    scrollToCatalogue() {
        scrollTo("#catalogue", 0, 1000);
    }
};
MainContentIntro = __decorate([
    Component({
        components: {
            ButtonApp,
        },
    })
], MainContentIntro);
export default MainContentIntro;
